import React, { useContext } from 'react';
import { useSubscription } from '@apollo/client';

import AuthContext from 'src/contexts/AuthContext';

import {
  USER_ACTIVITIES,
  USER_ACTIVITY_RECORDED,
} from './queries';

const useSubscriptions = () => {
  const { apolloClient: client } = useContext(AuthContext);

  useSubscription(USER_ACTIVITY_RECORDED, {
    onSubscriptionData: ({ subscriptionData: { data } }) => {
      if (!data || !data.userActivityRecorded) return;

      const newActivity = data.userActivityRecorded.userActivity;
      const cached = client.readQuery({ query: USER_ACTIVITIES });

      // Nothing has fetched the list yet, which means the chat is closed.
      // Seeding a cache entry here would stop the chat from fetching the
      // activities that were already recorded when it opens.
      if (!cached) return;

      const updatedActivities = cached.userActivities.filter(activity => (
        activity.id !== newActivity.id
      ));

      if (!newActivity.isDestroyed) {
        updatedActivities.push(newActivity);
      }

      client.writeQuery({
        query: USER_ACTIVITIES,
        data: { userActivities: updatedActivities },
      });
    }
  });
};

export default useSubscriptions;
